import React from 'react';
import Button from '../../common/Button/Button';
import Tooltip from '../../common/Tooltip';
import styles from './PaymentDetails.module.css';

interface SubscriptionHeaderActionsProps {
  onOpenPaymentLink?: () => void;
  onOpenPlanTransition?: () => void;
  onOpenPause?: () => void;
  onOpenResume?: () => void;
}

interface HeaderAction {
  label: string;
  icon: string;
  onClick: () => void;
}

const SubscriptionHeaderActions: React.FC<SubscriptionHeaderActionsProps> = ({
  onOpenPaymentLink,
  onOpenPlanTransition,
  onOpenPause,
  onOpenResume,
}) => {
  const actions: HeaderAction[] = [];

  if (onOpenPaymentLink) {
    actions.push({ label: 'Link de pagamento', icon: 'link', onClick: onOpenPaymentLink });
  }
  if (onOpenPlanTransition) {
    actions.push({ label: 'Troca de plano', icon: 'change_circle', onClick: onOpenPlanTransition });
  }
  if (onOpenResume) {
    actions.push({ label: 'Retomar assinatura', icon: 'play_circle', onClick: onOpenResume });
  } else if (onOpenPause) {
    actions.push({ label: 'Pausar assinatura', icon: 'pause_circle', onClick: onOpenPause });
  }

  return (
    <>
      {actions.map((action) => (
        <Tooltip key={action.label} content={action.label}>
          <Button
            type="button"
            variant="link"
            size="xs"
            icon={action.icon}
            iconSize={16}
            className={styles['btn-section-icon']}
            aria-label={action.label}
            onClick={action.onClick}
          />
        </Tooltip>
      ))}
    </>
  );
};

export default SubscriptionHeaderActions;
